import { journeyStateSelectors } from '~/api';

import {
  filterBySpec,
  specificationFactory,
  createMatcher,
  groupFacets,
} from '~/ocab-services/beauty/utils';

export const selectAppointmentTypes = (state) => state.appointmentTypes;

export const selectTreatments = ({ appointmentTypes, brands, treatmentCategories }) =>
  appointmentTypes.map(
    ({
      id,
      name,
      description,
      duration,
      price,
      beauty: {
        treatmentCategory: category,
        brand,
        bookingOption,
        patchOrAllergyTest,
        priceType,
        classification,
        relatedTreatmentIds,
        image,
      } = {},
      hasGroups,
    }) => ({
      id,
      name,
      description,
      duration,
      price,
      category: treatmentCategories.find((it) => it.id === category),
      brand: brands.find((it) => it.id === brand),
      bookingOption,
      patchOrAllergyTest,
      priceType,
      classification,
      hasGroups,
      relatedTreatmentIds,
      image,
    }),
  );

export const selectTreatmentsByFilters = (state) => {
  const selectedFacets = journeyStateSelectors.selectSelectedFacets(state);
  const facets = groupFacets(selectedFacets);
  const andMatchers = Object.entries(facets).map(([key, values]) =>
    specificationFactory.createOrSpec(
      ...values.map((value) => createMatcher(key, value, (itemValue) => itemValue.toLowerCase())),
    ),
  );
  const treatmentsList = selectTreatments(state);
  return filterBySpec(treatmentsList, specificationFactory.createAndSpec(...andMatchers));
};

export const appointmentTypesSelectors = {
  selectAppointmentTypes,
  selectTreatments,
  selectTreatmentsByFilters,
};
